module.exports = __webpack_public_path__ + "img/NaturalDisasterInformation.ba2bd8c4.svg";